import React, { PureComponent } from 'react';
import { PanelGroup, Panel } from 'react-bootstrap';
import SectionGroup from './sectionGroup';

class SectionsPanel extends PureComponent {
  state = {
    activeKey: '1',
  }

  handleSelect = (activeKey) => {
    this.setState({ activeKey });
  }

  render() {
    const {
      activeKey,
    } = this.state;

    return (

      <PanelGroup
        accordion
        id="sections-mobile-accordion"
        activeKey={activeKey}
        onSelect={this.handleSelect}
        className="sections-accordion-mobile"
      >
        {this.props.sections.map((section, index) => (
          <Panel className="sections-accordion-panel" eventKey={`${index + 1}`} key={`section-${index}`}>
            <Panel.Heading className="sections-accordion-heading">
              <Panel.Title className="sections-accordion-title" toggle>
                {section.label}
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body className="section-accordion-body" collapsible>
              {section.groups.map((group, index) => (
                <SectionGroup item={group} key={`section-group-${index}`} />
              ))}
            </Panel.Body>
          </Panel>
        ))}
      </PanelGroup>
    )
  }
}

export default SectionsPanel;



// WEBPACK FOOTER //
// ./src/app/screens/landing/sections/sectionsPanel.js